export default __webpack_public_path__ + "static/img/download_app_unsafe_image.4b419ca.png";